// developed by Param Partap Singh
import React from 'react'
import Nav from '../Utils/Nav'
import Footer from '../Utils/Footer'
import banner from '../Assets/background2.JPG'
import '../Css/Start.css'
import vpn from '../Assets/vpn-configuration.pdf'

export default function Start() {
  return (
    <>
    <Nav/>
    <div className='main-container'>
        <div className="banner">
            <img className="background" src={banner} alt="" />
            <h1 className="main-heading-title">Getting Started: Faculty, Staff and Students</h1>
        </div>

        <div className="page-content">
          <p>
          IIT Ropar provides students with various Computer Facilities which include Email, Web Browsing, Moodle, AIMS portal etc. It is suggested to use these facilities responsibly for your and IIT Ropar security.<br/><br/>
          The following information will be useful to you for accessing LDAP login and password:
          </p>
        </div>
          

        <div className="box-containt">
            <div className="box-n">
                <h2>LDAP Details</h2>
                <ul>
                    <li>For students : loginid is <b> Your_Entry_Number. </b>For faculty and staff login id is :<b> Email Prefix.</b></li>
                    <li>Your default LDAP password will be sent on your IITRPR Email id.</li>
                    <li>If for some reason your initial password does not work, please raise your concern at <b> <a href="https://iitrpr.ac.in/helpdesk" target="_blank">https://iitrpr.ac.in/helpdesk</a></b></li>
                    <li>To recover forgot password, Please click on the forgot password option available on the https://cas.iitrpr.ac.in/ webpage. A password reset link will be sent on your iitrpr email id.</li>
                </ul>    
            </div>
            <div className="box-n">
                <h2>Updating LDAP Details</h2>
                <ul>
                    <li>For LDAP password update/reset , it is recommended that you visit:<b> https://cas.iitrpr.ac.in/ </b>and do the following:</li>
                    <ul>
                        <li>Your LDAP password will be sent on your IITRPR Email id.</li>
                        <li>If for some reason your initial password does not work, please raise your concern at <b> <a href="https://iitrpr.ac.in/helpdesk" target="_blank">https://iitrpr.ac.in/helpdesk</a></b></li>
                    </ul>
                </ul>
            </div>
            <div className="box-n">
                <h2>Web Browsing and Email Account Access</h2>
                <ul>
                    <li>Abiding by the terms of use of IIT Ropar IT Resources by accepting the IIT Ropar IT Policy - This will enable you to browse the web and access your IIT Ropar Email Account (Webmail)</li>
                    <li>Detailed procedure for connecting to IIT Ropar network is mentioned below.
                        <ul style={{marginLeft:"20px"}}>
                            <li>Using Wired Network</li>
                            <li>Using Wireless</li>
                        </ul>
                    </li>
                    <li>For browsing IIT Ropar Internal service/websites from outside of IIT Ropar campus you need to connect through VPN <a href={vpn} target='_blank' style={{color:"red"}}>Main Campus</a></li>
                </ul>
            </div>
            
            
        </div>  






        {/* <div className="content-start">
            <h2>LDAP Details</h2>
            <ul>
                <li>For students : loginid is Your_Entry_Number. For faculty and staff login id is : Email Prefix.</li>
                <li>Your default LDAP password will be sent on your IITRPR Email id.</li>
                <li>If for some reason your initial password does not work, please contact to itteam@iitrpr.ac.in.</li>
                <li>To recover forgot password, Please click on the forgot password option available on the https://www.iitrpr.ac.in/cair/ webpage. A password reset link will be sent on your iitrpr email id.</li>
            </ul>
               
             <h2>Updating LDAP Details</h2>  
             <p>For LDAP password update/reset , it is recommended that you visit: https://www.iitrpr.ac.in/cair/ and do the following:</p>
             <ul>
                <li>Your LDAP password will be sent on your IITRPR Email id.</li>
                <li>If for some reason your initial password does not work, please contact to itteam@iitrpr.ac.in.</li>
             </ul>

             <h2>Web Browsing and Email Account Access</h2>
             <ul>
                <li>Abiding by the terms of use of IIT Ropar IT Resources by accepting the IIT Ropar IT Policy - This will enable you to browse the web and access your IIT Ropar Email Account (Webmail)</li>
                <li>
                    Detailed procedure for connecting to IIT Ropar network is mentioned below.
                    <ul>
                        <li>Using Wired Network</li>
                        <li>Using Wireless</li>
                    </ul>
                </li>
                <li>For browsing IIT Ropar Internal service/websites from outside of IIT Ropar campus you need to connect through VPN Main Campus.</li>
             </ul>


        </div> */}



    </div>
    <Footer/>
    </>
  )
}
